module.exports = __webpack_public_path__ + "assets/txtsizeauto copy.f7831549.svg";